import script from "./WechatBindingReminder.vue?vue&type=script&setup=true&lang=ts"
export * from "./WechatBindingReminder.vue?vue&type=script&setup=true&lang=ts"

import "./WechatBindingReminder.vue?vue&type=style&index=0&id=1489cc90&scoped=true&lang=css"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1489cc90"]])

export default __exports__